import axios from 'axios'

export type AdminRole = 'admin' | 'super_admin'

export interface AdminUser {
  admin_id: number
  username: string
  email: string | null
  role: AdminRole
  mfa_enabled: boolean
  is_active: boolean
  created_at: string
  last_login?: string | null
}

export function fetchAdminUsers() {
  return axios.get<AdminUser[]>('/api/admins/users').then((res) => res.data)
}

export function createAdminUser(payload: {
  username: string
  email?: string | null
  password: string
  role?: AdminRole
}) {
  return axios.post<AdminUser>('/api/admins/users', payload).then((res) => res.data)
}

export function updateAdminUser(adminId: number, payload: Record<string, unknown>) {
  return axios.patch<AdminUser>(`/api/admins/users/${adminId}`, payload).then((res) => res.data)
}

export function deleteAdminUser(adminId: number) {
  return axios.delete(`/api/admins/users/${adminId}`).then((res) => res.data)
}

export function setupMfa(adminId: number) {
  return axios.post<{ secret: string; provisioning_uri: string }>(`/api/admins/users/${adminId}/mfa/setup`).then((res) => res.data)
}

export function activateMfa(adminId: number, code: string) {
  return axios.post(`/api/admins/users/${adminId}/mfa/activate`, { code }).then((res) => res.data)
}

export function disableMfa(adminId: number) {
  return axios.delete(`/api/admins/users/${adminId}/mfa`).then((res) => res.data)
}
